import { DESKTOP_LINKS, MOBILE_NAVIGATION } from '../../lib/navigation'

export const getDesktopNavigationList = () => {
  return DESKTOP_LINKS
}

export const getMobilePrimaryNavigation = () => {
  return MOBILE_NAVIGATION.navPrimary
}
